import { useAdDetails } from '@/views/Ads/useAdDetails';
import { ContactType } from '@/api/types/ads.types';
import { useServerDataContext } from '@/contexts';

export function useFloatingButtonsVisibility() {
  const { adDetails } = useAdDetails();
  const { initialAdDetails } = useServerDataContext();
  const adData = adDetails ?? initialAdDetails;

  const isChatAvailable =
    adData?.isChatAvailable &&
    (adData?.contact.type === ContactType.OnlyMessages ||
      adData?.contact.type === ContactType.CallsAndMessages);

  const isCallsAvailable =
    adData?.isCallsAvailable &&
    (adData?.contact.type === ContactType.OnlyCalls ||
      adData?.contact.type === ContactType.CallsAndMessages);

  return { isChatAvailable, isCallsAvailable };
}
